module.exports = __webpack_public_path__ + "img/teap.f22fb1d4.png";